<template>
  <v-container class="pt-0">
    <v-row>
      <v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" :text="title" />
      </v-col>
    </v-row>

    <v-container fluid class="pa-0">
      <v-row justify="center">
        <v-col cols="12" sm="8" class="mt-2">
          <!-- Tier Card -->
          <v-card
            v-if="profileData"
            class="level-card mb-5 relative mx-0"
            :style="{
              backgroundColor: profileData.level_color,
              color: getFontColorBasedOnBg(profileData.level_color, 'bw'),
            }"
            elevation="3"
          >
            <v-container class="pa-4">
              <v-row align="center">
                <v-col cols="8" class="mt-4">
                  <div
                    class="tier-label"
                    :style="{
                      background: setBackgoundBox(),
                    }"
                  >
                    {{ $t("memberLevel") }}
                  </div>
                  <div class="level-name">{{ profileData.level }}</div>
                  <div class="member-name">
                    {{ profileData.name }} {{ profileData.surname }}
                  </div>
                  <div class="member-points">
                    <div
                      v-if="
                        Array.isArray(profileData.point) &&
                        profileData.point.length > 0
                      "
                      class="d-flex align-center justify-center"
                      style="width: 100%; gap: 4px"
                    >
                      <PointSymbol
                        :type="profileData.point[0].point_type_type"
                        :symbol="profileData.point[0].point_type_symbol"
                        :color="profileData.point[0].point_type_color"
                        :is_display="true"
                        :outlined_box="false"
                        :size="32"
                      />
                      <div style="font-size: 20px; font-weight: bold">
                        {{ commaPoint(profileData.point[0].point || 0) }}
                      </div>
                      <div class="text-truncate" style="font-size: 16px">
                        {{ profileData.point[0].point_type_name }}
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="4" class="d-flex justify-end">
                  <div class="level-image-container">
                    <v-img
                      v-if="profileData.image"
                      :src="profileData.image"
                      class="level-image"
                      aspect-ratio="1"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>

          <!-- Progress Bar -->
          <div v-if="profileData" class="progress-section mb-5 mx-0">
            <v-progress-linear
              :value="percentNextLevel"
              :color="profileData.level_color"
              background-color="#E8E8E8"
              height="12"
              class="progress-bar"
            />
            <div class="progress-info">
              <span v-if="!isLastLevel">
                {{
                  $t("earnMoreForNextLevel", {
                    nextLevelEarn:
                      commaPoint(profileData.next_level_earn || 0) +
                      (profileData.next_level_point_type &&
                      profileData.next_level_point_type.name
                        ? " " + profileData.next_level_point_type.name
                        : ""),
                    nextLevelName: profileData.next_level_name,
                  })
                }}
              </span>
              <span v-else>
                {{ $t("maxLevelReached") }}
              </span>
            </div>
          </div>

          <!-- Tier Tabs -->
          <v-card
            v-if="profileData && profileData.level_detail"
            class="tier-tabs-card"
          >
            <v-tabs
              v-model="activeTab"
              class="tier-tabs"
              :color="site.color || 'primary'"
            >
              <v-tab
                v-for="level in profileData.level_detail"
                :key="level.id"
                class="tier-tab"
              >
                {{ level.name }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
              <v-tab-item
                v-for="level in profileData.level_detail"
                :key="level.id"
              >
                <div
                  v-if="level.detail"
                  class="ql-editor tier-detail mb-4"
                  style="height: fit-content"
                  v-html="level.detail"
                />
                <div
                  v-else
                  class="d-flex justify-center mt-4 mb-4"
                  style="width: 100%"
                >
                  {{ $t("errDataNotFound") }}
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import {
  adjustHslBrightness,
  getFontColorBasedOnBg,
} from "@/config/general-function";
import PointSymbol from "../../../components/point/point-symbol.vue";

export default {
  components: {
    HeaderTextBg,
    PointSymbol,
  },
  inject: ["isAppLoading"],
  data: () => ({
    title: "",
    profileData: null,
    activeTab: 0,
  }),
  created() {
    const menu = JSON.parse(this.site.menu_account);
    const model = menu?.find((x) => x.to == "level-detail");
    this.title = model?.name;
    // ========== ========== Profile ========== ==========
    const _profileData = this.getCustomer || {};
    this.profileData = _profileData;
    const currentLevelIndex = this.profileData.level_detail.findIndex(
      (level) => level.name === this.profileData.level
    );
    if (currentLevelIndex !== -1) {
      this.activeTab = currentLevelIndex;
    }
    // ========== ========== ========== ==========
  },
  methods: {
    getCurrentLevelMaxPoint() {
      if (!this.profileData || !this.profileData.level_detail) return 0;
      const currentLevel = this.profileData.level_detail.find(
        (level) => level.name === this.profileData.level
      );
      if (currentLevel) {
        return currentLevel.max_point;
      }
      return 0;
    },
    getFontColorBasedOnBg(param, param2) {
      const res = getFontColorBasedOnBg(param, param2);
      return res;
    },
    setBackgoundBox() {
      const _color = this.profileData.level_color;
      const darken = adjustHslBrightness(_color, -20);
      let _style = `linear-gradient(120deg, ${_color}, ${darken})`;
      return _style;
    },
    commaPoint(value) {
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    getCustomer() {
      return { ...this.$store.getters["defaultSystem/getCustomer"] };
    },
    isLastLevel() {
      if (!this.profileData?.level_detail) return false;
      // Find the level with the highest min_point
      const highestLevel = this.profileData.level_detail.reduce(
        (max, current) => {
          const currentMinPoint = parseInt(current.min_point || 0);
          const maxMinPoint = parseInt(max.min_point || 0);
          return currentMinPoint > maxMinPoint ? current : max;
        }
      );
      return this.profileData.level === highestLevel.name;
    },
    percentNextLevel() {
      let percent = 100;
      const _point = this.profileData?.history_point || 0;
      const _nextLevelEarn = this.profileData?.next_level_earn || 0;
      const max = _point + _nextLevelEarn;
      if (this.profileData?.next_level_name) {
        if (max > 0) {
          percent = (_point * 100) / max;
        }
      }
      return percent;
    },
  },
  filters: {},
};
</script>

<style scoped>
.level-card {
  border-radius: 12px !important;
  color: #333;
  overflow: hidden;
}

.tier-label {
  font-size: 12px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 6px 12px;
  display: inline-block;
  margin-bottom: 8px;
  position: absolute;
  top: 0px;
  left: 0px;
  border-bottom-right-radius: 20px;
}

.level-name {
  font-size: 32px;
  font-weight: 700;
  margin: 5px 0;
}

.member-name {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 15px;
}

.member-points {
  display: flex;
  align-items: center;
  gap: 8px;
}

.point-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background-color: #ffc107;
  border-radius: 50%;
  font-weight: 700;
  font-size: 14px;
  color: #333;
}

.level-image {
  border-radius: 12px;
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.level-image-container {
  width: 100%;
  max-width: 120px;
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 12px;
}

.progress-section {
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 12px;
}

.progress-label {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #666;
}

.progress-label.text-center {
  justify-content: center;
}

.progress-bar {
  border-radius: 6px !important;
  margin: 10px 0;
}

.progress-info {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
  line-height: 1.6;
}

.tier-tabs-card {
  border-radius: 12px;
  box-shadow: none !important;
}

::v-deep .tier-tabs-card .v-slide-group__prev,
::v-deep .tier-tabs-card .v-slide-group__next {
  display: none !important;
}

.tier-tabs {
  padding: 0 16px;
}

.tier-tab {
  position: relative;
  font-weight: 600;
  text-transform: capitalize;
  min-width: auto;
  flex: 1 1 auto;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .tier-tab {
    font-size: 12px;
  }
}
.ql-editor.tier-detail {
  padding: 0 14px;
  margin-top: 12px;
}
</style>

